module.exports = __webpack_public_path__ + "static/media/PM 100px.8f70625b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PM 100px.png
// module id = 239
// module chunks = 0